export default "__VITE_ASSET__Cyfh7hxV__"